import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import { Divider, Card, Row, Col, Input } from 'antd';
import CopyToClipboard from 'react-copy-to-clipboard';
import styles from '../css/streams.module.css';
import Auth from './components/auth';
import Status from './components/status';

import iconCreate from '../assets/create.png';
import iconDel from '../assets/delete.png';
import iconStop from '../assets/stop.png';
import logoWeibo from '../assets/desktop_live_ic_weibo@2x.png';
import imgProLiveTool from '../assets/pro_live_tool.jpg';

@inject('app', 'weibo')
@observer
export default class Streams extends Component {
  componentDidMount() {
    const { app } = this.props;
    app.setBreadcrumbs(['live', 'weibo_streams'], 'weibo');
  }

  stop(id) {
    const { weibo } = this.props;
    weibo.update({
      id,
      stop: '1',
    });
  }

  destroy(id) {
    const { weibo } = this.props;
    weibo.remove(id);
  }

  render() {
    const { langs } = this.props.app;

    const { weibo } = this.props;
    const streams = weibo.streams.keys().reverse();

    return (
      <div className={styles.content}>
        <div className={styles.header}>
          <img src={logoWeibo} className={styles.logo}></img>
          <Link className={styles.create} to={'/live/weibo/create'}>
            <img src={iconCreate} alt="" />
            <span>{langs['live_create']}</span>
          </Link>
        </div>

        <Divider />

        <Row gutter={16}>
          {streams.length > 0 && streams.map((s, i) => {
            const stream = weibo.streams.get(s);
            const detail = weibo.details.get(s);
            if (!stream || !detail) {
              return null;
            }

            const urlArray = stream.url.split('/');
            const authKey = urlArray.pop();
            const pushUrl = urlArray.join('/');

            return (
              <Col xs={24} md={8} key={i} style={{ marginTop: '1em' }}>
                <Card
                  cover={
                    <div className={styles.card_head}>
                      <img className={styles.img} alt="pro_live_tool" src={imgProLiveTool} />

                      <div className={styles.status}>
                        <Status code={detail.status} />
                      </div>

                      <div className={styles.action}>
                        {detail.status == 1?(
                          <img src={iconStop} onClick={() => { this.stop(detail.id) }} alt=""/>
                        ):null}
                        {detail.status >= 3?(
                          <img src={iconDel} onClick={() => { this.destroy(detail.id) }} alt=""/>
                        ):null}
                      </div>
                    </div>
                  }
                  className={styles.card}
                  actions={[
                    <CopyToClipboard text={pushUrl}><span>{langs['live_fb_streams_push_addr_copy']}</span></CopyToClipboard>,
                    <CopyToClipboard text={authKey}><span>{langs['live_fb_streams_push_secret_copy']}</span></CopyToClipboard>
                  ]}
                >
                  <Card.Meta title={detail.title} description={detail.summary} />
                  <p>{langs['live_fb_streams_push_addr']}</p>
                  <Input readOnly={true} value={pushUrl} />
                  <p>{langs['live_fb_streams_push_secret']}</p>
                  <Input readOnly={true} value={authKey} />
                  <p style={{color: 'red'}}>{langs['live_streams_note']}</p>
                </Card>
              </Col>
            );
          })}

          {streams.length === 0?(
            <Col xs={24} md={8}>
              <Link to={'/live/weibo/create'}>
                <Card
                  hoverable
                  cover={<img alt="pro_live_tool" src={imgProLiveTool} />}
                >
                  <Card.Meta
                    title="Insta360 Pro"
                    description="Professional Pano Camera"
                  />
                </Card>
              </Link>
            </Col>
          ):null}
        </Row>

        <Auth />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/views/live/weibo/streams.js